export default {
      id: "Icon--link-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--link",
      toString: function () {
        return this.url;
      }
    }